<template>
  <v-slide-y-transition>
    <v-system-bar v-if="urgentNotification?.enabled" class="text-body-2 black--text" :color="notificationValue?.color" app>
      <v-container class="text-center  d-flex justify-center">
        <span v-if="description">
          {{ description }}
        </span>

        <a v-if="link && link.isVisible" class="align-center d-flex ms-2" :href="link.href" target="_blank" :title="link.title">
          {{ link.title }}
        </a>
      </v-container>
    </v-system-bar>
  </v-slide-y-transition>
</template>

<script lang="ts" setup>
import { useFlags } from 'flagsmith-vue';
import { computed } from 'vue';
import { useI18n } from '@/helpers/i18n';

const i18n = useI18n();

const { urgent_notification: urgentNotification } = useFlags(['urgent_notification']);

const notificationValue = computed(() => {
  if (!urgentNotification.value) {
    return null;
  }

  try {
    return JSON.parse(urgentNotification.value.value as string);
  } catch {
    return null;
  }
});

const description = computed(() =>
  notificationValue.value
    ? notificationValue.value[i18n.locale].description
    : '');

const link = computed(() =>
  notificationValue.value
    ? notificationValue.value[i18n.locale].link
    : '');
</script>
